import React from 'react';
import {
    Box,
    Chip,
    Typography,
    IconButton,
} from '@material-ui/core';

import { SparkManagerContext } from './ManagerContext';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
// import ClearIcon from '@material-ui/icons/Clear';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { theme } from './Styles';
import { ThemeProvider } from '@material-ui/styles';
function TagsPanel({ tags, updateTags, mode }) {
    const masterContext = React.useContext(SparkManagerContext);
    const [showUnassigned, setShowUnasigned] = React.useState(false);
    const [activeCategory, setActiveCategory] = React.useState('');

    const [visibleTags, setVisibleTags] = React.useState({});
    const [hiddenTags, setHiddenTags] = React.useState({});

    React.useEffect(() => {
        const v = {};
        const h = {};
        Object.keys(masterContext.tags).forEach((category) => {
            v[category] = tags?.[category]?.map((id) => masterContext.tags[category].find((t) => t.id === id));
            h[category] = masterContext.tags?.[category].filter((mt) => !tags?.[category]?.find((t) => mt.id === t));
        });
        setVisibleTags(v);
        setHiddenTags(h);
    }, [tags, masterContext.tags]);

    const showTagPicker = (category) => {
        if(mode==='edit'){
            if (!showUnassigned) {
                setActiveCategory(category);
                setShowUnasigned(true);
            } else {
                if (category === activeCategory) {
                    setActiveCategory('');
                    setShowUnasigned(false);
                } else {
                    setActiveCategory(category);
                }
            }
        }
    };

    const addTagClicked = (category, id) => {
        const list = tags?.[category] || [];
        const newTags = { ...tags, [category]: [...list, id] };
        console.log({ newTags });
        updateTags(newTags);
    };

    const removeTagClicked = (category, id) => {
        const list = tags?.[category] || [];
        const newTags = { ...tags, [category]: list.filter((t) => t !== id) };
        console.log({ newTags, id });
        updateTags(newTags);
    };
   
    return (
        <ThemeProvider theme={theme}>
        <Box mr={2} flex="0 0 400px">


            <Box
                p={2}
                flexDirection="column"
                display="flex"
                style={{ borderRadius: '5px', border: '0px solid #D1CCCC' }}
            >
                {Object.keys(visibleTags).map((category) => (
                    <Box key={category} flex="1" flexDirection="column" display="flex" mr={2}>
                        <Box display="flex" flexDirection="row" justifyContent="flex-start">
                            <IconButton
                                aria-label="map"
                                size="small"
                                onClick={() => showTagPicker(category)}
                                style={{ fontSize: '28px' }}
                            >
                                {activeCategory === category && showUnassigned ? (
                                    <HighlightOffIcon size="small" style={{ color: '#300' }} />
                                ) : (
                                    <AddCircleOutlineIcon size="small" style={{ color: '#009' }} />
                                )}
                            </IconButton>
                            <Typography variant="overline" gutterBottom>
                                {category}
                            </Typography>
                        </Box>
                        <Box display="flex" flexDirection="row" justifyContent="flex-start" mr={2} flexWrap="wrap">
                            {visibleTags[category] ? (
                                visibleTags[category].sort((a, b) => a.name > b.name ? 1 : -1)?.map((t) => (
                                    t ?
                                    <Chip
                                        key={category + '_' + t?.id}
                                        size="medium"
                                        label={t?.name}
                                        color="secondary"
                                        style={{
                                            backgroundColor: '#F2F4F7',
                                            padding: '2px 6px',
                                            marginRight: '6px',
                                            marginBottom: '6px',
                                            fontSize: '12px',
                                        }}
                                        onDelete={
                                            activeCategory === category && showUnassigned
                                                ? () => removeTagClicked(category, t?.id)
                                                : null
                                        }
                                    /> : ''
                                ))
                            ) : (
                                <Typography variant="button" gutterBottom>
                                    {' '}
                                    None Assigned{' '}
                                </Typography>
                            )}
                        </Box>
                        {activeCategory === category && showUnassigned && (
                            <Box
                                display="flex"
                                flexDirection="row"
                                justifyContent="flex-start"
                                mr={2}
                                mt={1}
                                flexWrap="wrap"
                            >
                                {hiddenTags[category] ? (
                                    hiddenTags[category].sort((a, b) => a.name > b.name ? 1 : -1)?.map((t) => (
                                        t ?
                                        <Chip
                                            key={category + '_' + t?.id}
                                            size="medium"
                                            variant="outlined"
                                            label={t?.name}
                                            clickable={true}
                                            icon={<AddCircleOutlineIcon />}
                                            style={{
                                                fontSize: '12px',
                                            }}
                                            onClick={() => {
                                                addTagClicked(category, t?.id);
                                            }}
                                        /> : ''
                                    ))
                                ) : (
                                    <Typography variant="button" gutterBottom>
                                        {' '}
                                        None Available{' '}
                                    </Typography>
                                )}
                            </Box>
                        )}
                    </Box>
                ))}
            </Box>
        </Box>
        </ThemeProvider>
    );
}

export default TagsPanel;